/* knowledge-badge.tsx generated by @compiled/babel-plugin v0.38.1 */
import "./knowledge-badge.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import Button from '@atlaskit/button';
import { IconTile } from '@atlaskit/icon';
import BookWithBookmarkIcon from '@atlaskit/icon/core/book-with-bookmark';
import { Box, Inline, Text } from '@atlaskit/primitives/compiled';
var styles = {
  knowledgeBadge: "_2rko12b0 _189ee4h9 _1h6d1l7x _1dqonqa1 _1e0c116y",
  buttonLink: "_ca0qv77o _u5f3v77o _n3tdv77o _19bvv77o _18u0v77o _2hwx1b66"
};
export var KnowledgeBadge = function KnowledgeBadge(_ref) {
  var name = _ref.name,
    url = _ref.url,
    _ref$onBadgeClick = _ref.onBadgeClick,
    onBadgeClick = _ref$onBadgeClick === void 0 ? function () {} : _ref$onBadgeClick;
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.knowledgeBadge,
    backgroundColor: "color.background.input"
  }, /*#__PURE__*/React.createElement(Button, {
    href: url,
    appearance: "subtle",
    onClick: function onClick() {
      onBadgeClick();
    },
    spacing: "none",
    target: "_blank"
  }, /*#__PURE__*/React.createElement(Inline, {
    space: "space.050",
    alignBlock: "center",
    xcss: styles.buttonLink
  }, /*#__PURE__*/React.createElement(IconTile, {
    icon: BookWithBookmarkIcon,
    label: "",
    appearance: "blue",
    size: "16"
  }), /*#__PURE__*/React.createElement(Text, null, name))));
};